import React from "react";
import ReactModal from "react-modal";

import "../../modal.css";

export interface IModalDialogBaseProps {
    isOpen: boolean;
    onRequestClose: (requestRefresh?: boolean) => void;
}

interface IModalDialogProps extends IModalDialogBaseProps {
    contentLabel?: string;
    title?: string;

    className?: string;
}

class ModalDialog extends React.Component<IModalDialogProps> {
    requestClose: () => void;

    constructor(props: Readonly<IModalDialogProps>) {
        super(props);

        this.requestClose = this.props.onRequestClose.bind(this, false);
    }

    public render() {
        return (
            this.props.isOpen
                ? <ReactModal
                    isOpen={this.props.isOpen} onRequestClose={this.requestClose}
                    overlayClassName="modal-overlay" bodyOpenClassName="modal-open" portalClassName="modal-portal"
                    className={"modal-dialog-content" + (this.props.className ? " " + this.props.className : "")} contentLabel={this.props.contentLabel}>
                    <header>
                        <span>{this.props.title === undefined ? "NO TITLE SET" : this.props.title}</span>
                        <div className="modal-dialog-button-container">
                            <button title="Close" onClick={this.requestClose}><i className="icon-close" /></button>
                        </div>
                    </header>
                    {this.props.children}
                </ReactModal>
                : null
        );
    }
}

export default ModalDialog;
